import { ItemCodeGenerationMethod } from '../../config/config';

const JOKER_FIELD_PREFIXES = ['joker_char', 'joker_date', 'joker_num', 'joker_int'];
const CLASS_FLAG_PREFIX = 'class';

export const getItemCodeGenerationMethod = (config) => {
  return config?.itemCodeGenerationMethod ?? ItemCodeGenerationMethod.LEGACY;
};

export const isCustomItemCodeGenerationEnabled = (config) => {
  return getItemCodeGenerationMethod(config) !== ItemCodeGenerationMethod.LEGACY;
};

export const getDefaultCustomItemCodePolicy = () => {
  return {
    autoGenerateDefault: false,
    autoGenerateVisible: true,
    autoGenerateLocked: false,
    manualAllowed: true,
    manualPrefix: '',
  };
};

export const normalizeGeneratedItemCode = (response) => {
  return (
    response?.itemCode ??
    response?.code ??
    response?.data?.itemCode ??
    response?.data?.code ??
    (typeof response === 'string' ? response : null)
  );
};

export const extractItemCodeJokerValues = (values) => {
  return Object.fromEntries(
    Object.entries(values ?? {}).filter(
      ([key, value]) => JOKER_FIELD_PREFIXES.some((prefix) => key.startsWith(prefix)) && value !== '' && value !== null
    )
  );
};

export const extractItemCodeClassFlags = (values) => {
  return Object.fromEntries(
    Object.entries(values ?? {}).filter(
      ([key, value]) => key.startsWith(CLASS_FLAG_PREFIX) && typeof value === 'boolean'
    )
  );
};

export const buildItemCodeRequest = (values, autoGenerate) => {
  return {
    itemGroupId: values?.itemGroupId ?? null,
    type: values?.type ?? null,
    stockItemType: values?.stockItemType ?? null,
    itemCode: autoGenerate ? null : values?.itemCode ?? null,
    jokerValues: extractItemCodeJokerValues(values),
    classFlags: extractItemCodeClassFlags(values),
    autoGenerate,
  };
};

export const buildItemCodePolicyRequest = (values) => {
  return {
    itemGroupId: values?.itemGroupId ?? null,
    type: values?.type ?? null,
    stockItemType: values?.stockItemType ?? null,
    jokerValues: extractItemCodeJokerValues(values),
    classFlags: extractItemCodeClassFlags(values),
  };
};

export const getProtectedManualItemCode = (itemCode, manualPrefix) => {
  if (!manualPrefix) {
    return itemCode;
  }

  const nextValue = itemCode ?? '';
  if (nextValue.startsWith(manualPrefix)) {
    return nextValue;
  }

  const sanitizedValue = nextValue.replace(manualPrefix, '');
  return `${manualPrefix}${sanitizedValue}`;
};

export const getManualItemCodeSuffix = (itemCode, manualPrefix) => {
  if (!manualPrefix) {
    return itemCode ?? '';
  }

  return (itemCode ?? '').startsWith(manualPrefix) ? (itemCode ?? '').slice(manualPrefix.length) : itemCode ?? '';
};
